/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Product_Image_File_Too_LargeInputs */

const vi_error_product_image_file_too_large = /** @type {(inputs: Error_Product_Image_File_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File ảnh lớn quá ${i?.max} MB. Giảm dung lượng ảnh rồi thử lại.`)
};

/**

* @param {Error_Product_Image_File_Too_LargeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_image_file_too_large = /** @type {((inputs: Error_Product_Image_File_Too_LargeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Image_File_Too_LargeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_image_file_too_large(inputs)
});